import { ListGroup } from "react-bootstrap";
import "../../css/Blog.css";

const BlogSidebar = ({
  categories,
  tags,
  selectedCategory,
  selectedTags,
  onCategorySelect,
  onTagSelect,
  activeSection,
  onSectionSelect,
}) => {
  // Sort categories and tags alphabetically
  const sortedCategories = [...categories].sort((a, b) =>
    a.name.localeCompare(b.name),
  );
  const sortedTags = [...tags].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="blog-sidebar">
      <h5 className="mb-3">Content</h5>
      <ListGroup className="mb-4">
        <ListGroup.Item
          action
          active={activeSection === "blogs"}
          onClick={() => onSectionSelect("blogs")}
        >
          Blog Posts
        </ListGroup.Item>
        <ListGroup.Item
          action
          active={activeSection === "talks"}
          onClick={() => onSectionSelect("talks")}
        >
          Talks & Presentations
        </ListGroup.Item>
      </ListGroup>

      <>
        <h5>Categories</h5>
        <ListGroup className="mb-4 blog-categories">
          <ListGroup.Item
            action
            active={!selectedCategory}
            onClick={() => onCategorySelect(null)}
          >
            All Posts
          </ListGroup.Item>
          {sortedCategories.map((category) => (
            <ListGroup.Item
              key={category.id}
              action
              active={category.slug === selectedCategory}
              onClick={() => onCategorySelect(category.slug)}
            >
              {category.name}
              {/* <Badge bg="secondary" className="float-end">
              {category.post_count}
            </Badge> */}
            </ListGroup.Item>
          ))}
        </ListGroup>

        <h5>Tags</h5>
        <div className="blog-tags mb-4">
          {sortedTags.map((tag) => (
            <span
              key={tag.id}
              className={`me-2 mb-2 blog-tag-badge${selectedTags.includes(tag.slug) ? " blog-tag-badge--active" : ""}`}
              style={{ cursor: "pointer", display: "inline-block" }}
              onClick={() => onTagSelect(tag.slug)}
            >
              {tag.name}
            </span>
          ))}
        </div>
      </>
    </div>
  );
};

export default BlogSidebar;
